module.exports = __webpack_public_path__ + "img/logo_small.5d0f944a.svg";